import { render, staticRenderFns } from "./havayollaricomp.vue?vue&type=template&id=456f35bd"
import script from "./havayollaricomp.vue?vue&type=script&lang=js"
export * from "./havayollaricomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports